export type GemzTrade = 'Buy' | 'Sell';
export type LogSource = 'on-chain' | 'off-chain';

export interface GemzAuditLogSchema {
    game_id?: number;
    offchain_game_id: number;
    user_id: number;
    trade: GemzTrade;
    wallet_address: string;
    transaction_hash: string;
    price: number;
    pool_id: number;
    amount: number;
    supply: number;
    protocol_reward: number;
    creator_reward: number;
    pool_reward: number;
    ip_holder_reward: number;
    source: LogSource;
}

export interface GemzAuditLog {
    onChainGameId?: number;
    offChainGameId: number;
    userId: number;
    trade: GemzTrade;
    walletAddress: string;
    transactionHash: string;
    price: number;
    poolId: number;
    amount: number;
    supply: number;
    protocolReward: number;
    creatorReward: number;
    poolReward: number;
    ipHolderReward: number;
    source: LogSource;
}

export const getGemzAuditLogFromSchema = (schema: GemzAuditLogSchema): GemzAuditLog => ({
    onChainGameId: schema.game_id,
    offChainGameId: schema.offchain_game_id,
    userId: schema.user_id,
    trade: schema.trade,
    walletAddress: schema.wallet_address,
    transactionHash: schema.transaction_hash,
    price: schema.price,
    poolId: schema.pool_id,
    amount: schema.amount,
    supply: schema.supply,
    protocolReward: schema.protocol_reward,
    creatorReward: schema.creator_reward,
    poolReward: schema.pool_reward,
    ipHolderReward: schema.ip_holder_reward,
    source: schema.source,
})
